import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=bccf0d38&scoped=true&"
import script from "./Checkbox.vue?vue&type=script&lang=js&"
export * from "./Checkbox.vue?vue&type=script&lang=js&"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=bccf0d38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.0_m252fu66fivcrdajfhoxhvxrne/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccf0d38",
  null
  
)

export default component.exports